import React, { useEffect, useState } from 'react';
import Heading from '../../../../../common/element/Heading';
import { setBreadcrumbs } from '../../../../../redux/Admin/breadcrumbsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import CompanyInfoCard from './Tabs/OverView/OverView';
// import InterViewCandidate from './Tabs/Interview Candidate/InterView';
import InterViewCandidate from '../../Companies/View/Tabs/Interview Candidate/InterView';
import Button from '../../../../../common/element/Buttons';

// ✅ Import action and selectors
import {
  getCompanyAdhocDetail,
  clearCompanyAdhocDetail
} from '../../../../../redux/AdhocCompany/Companyadhocslice';
import {
  selectCompanyAdhocDetail,
  selectCompanyAdhocDetailLoading,
  selectCompanyAdhocDetailError,
} from '../../../../../redux/AdhocCompany/Companyadhocselectors';
import ThreeDotBouncingLoader from '../../../../../common/element/ButtonLoader/ThreeDotBouncingLoder';

const ViewAdhocCompany = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  // ✅ Read URL params
  const searchParams = new URLSearchParams(location.search);
  const tabFromUrl = searchParams.get('tab') || 'overview';
  const id = searchParams.get('companyId');
  const companyNameFromUrl = searchParams.get('companyName');

  // ✅ Set active tab from URL
  const [activeTab, setActiveTab] = useState(tabFromUrl);

  // ✅ Get company data from Redux store using selectors
  const companyData = useSelector(selectCompanyAdhocDetail);
  const loading = useSelector(selectCompanyAdhocDetailLoading);
  const error = useSelector(selectCompanyAdhocDetailError);
  console.log(companyData, "cccccc");
  // ✅ Fetch company details on mount
  useEffect(() => {
    if (id) {
      dispatch(getCompanyAdhocDetail(id));
    }

    // Cleanup on unmount
    return () => {
      dispatch(clearCompanyAdhocDetail());
    };
  }, [dispatch, id]);

  // ✅ Update state when URL changes
  useEffect(() => {
    setActiveTab(tabFromUrl);
  }, [tabFromUrl]);

  // ✅ Handle tab change
  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    const params = new URLSearchParams(location.search);
    params.set('tab', tabId);
    navigate(`?${params.toString()}`, { replace: true });
  };

  // ✅ Set breadcrumbs
  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        { label: "Adhoc Company", url: "/adhoc-company", home: "/companies" },
        { label: companyNameFromUrl || companyData?.company_name || "View Adhoc Company", url: `/adhoc-company/view?companyId=${id}&tab=${tabFromUrl}&companyName=${companyNameFromUrl}` },
      ])
    );
  }, [dispatch, id, tabFromUrl, companyNameFromUrl, companyData]);

  // ✅ Tabs (only Overview + Interview Candidates)
  const tabs = [
    { id: 'overview', label: 'Overview' },
    { id: 'interviewCandidates', label: 'Interview Candidates' },
  ];

  // ✅ Helper function to format phone number
  const formatPhoneNumber = (phone) => {
    if (!phone) return 'N/A';
    // If phone starts with country code like 91, format it
    if (phone.length > 10) {
      const countryCode = phone.slice(0, phone.length - 10);
      const number = phone.slice(-10);
      return `+${countryCode} ${number.slice(0, 5)} ${number.slice(5)}`;
    }
    return phone;
  };

  // ✅ Get HR status
  const getHRStatus = () => {
    if (companyData?.hr?.isActive) {
      return 'Active';
    }
    return 'Inactive';
  };

  // ✅ Loading state
  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <ThreeDotBouncingLoader />
      </div>
    );
  }

  // ✅ Error state
  if (error) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-red-500 text-center">
          <p className="text-lg font-semibold">Error loading company details</p>
          <p className="text-sm mt-2">{error}</p>
          <Button
            onClick={() => dispatch(getCompanyAdhocDetail(id))}
            className="mt-4"
          >
            Retry
          </Button>
        </div>
      </div>
    );
  }

  // ✅ No data state
  if (!companyData) {
    return (
      <div className="flex justify-center items-center h-64">
        <p className="text-gray-500">No company data found</p>
      </div>
    );
  }

  return (
    <div>
      <div className="flex justify-between mb-5">
        <div className="w-full">
          {/* ✅ Header Section */}
          <div className="flex items-center gap-4 mb-6">
            {/* Company Logo Placeholder */}
            <div className="w-14 h-14 bg-gray-300 rounded-full overflow-hidden flex items-center justify-center">
              {companyData?.logo ? (
                <img
                  src={companyData.logo}
                  alt={companyData?.company_name}
                  className="w-full h-full object-cover"
                />
              ) : (
                <span className="text-xl font-bold text-gray-500">
                  {companyData?.company_name?.charAt(0)?.toUpperCase() || 'C'}
                </span>
              )}
            </div>

            <div>
              {/* Company Name */}
              <div className="text-start">
                <Heading>
                  {companyData?.company_name || companyNameFromUrl || 'N/A'}
                </Heading>
              </div>

              {/* Status & Phone */}
              <div className="flex items-center gap-3 mt-1">
                {/* Status Badge */}
                <div className={`flex items-center gap-1 px-3 py-0.5 rounded-[16px] ${companyData?.company_isActive == true
                  ? 'bg-[#ECFDF3]'
                  : 'bg-[#FEF3F2]'
                  }`}>
                  <div className={`w-2 h-2 rounded-full ${companyData?.company_isActive == true
                    ? 'bg-green-500'
                    : 'bg-red-500'
                    }`}></div>
                  <span className={`font-lato font-medium text-[14px] ${companyData?.company_isActive == true
                    ? 'text-[#027A48]'
                    : 'text-[#B42318]'
                    }`}>
                    {companyData?.company_isActive == true ? 'Active' : 'Inactive'}
                  </span>
                </div>

                {/* Contact Phone */}
                <span className="font-lato font-medium text-[14px] text-[#1D2939]">
                  {formatPhoneNumber(companyData?.contact_phone)}
                </span>
              </div>
            </div>
          </div>

          {/* ✅ Tabs */}
          <div className="flex gap-0 p-1 bg-[#FFF4E5] border border-[#FFF4E5] rounded-lg mb-6">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => handleTabChange(tab.id)}
                className={`flex-1 text-sm font-normal transition-colors py-2 px-3 rounded-md ${activeTab === tab.id
                  ? 'text-gray-900 bg-white shadow-[0px_1px_3px_rgba(16,24,40,0.1),0px_1px_2px_rgba(16,24,40,0.06)]'
                  : 'text-gray-600 bg-[#FFF4E5]'
                  }`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* ✅ Tab Content */}
          {activeTab === 'overview' && <CompanyInfoCard companyData={companyData} />}
          {activeTab === 'interviewCandidates' && (
            <InterViewCandidate companyData={companyData} />


          )}
        </div>
      </div>
    </div>
  );
};

export default ViewAdhocCompany;